import { Box, Flex } from "@chakra-ui/react";
import { MotionGrid, viewAppearDefault } from "utils/motion";
import Text from "components/base/Text";
import Description from "components/base/Description";
import Container from "components/base/Container";
import ArrowButton from "components/blocks/ArrowButton";
import Image from "components/base/Image";

export default function LinkColumnsSection({
  title,
  description,
  image,
  ctaText,
  cta,
  inverted,
  bg,
}) {
  const textColor = inverted ? "black.900" : "white";

  return (
    <Box width="100%" bg={bg || (inverted ? "white" : "black.900")}>
      <Container>
        <MotionGrid
          variants={viewAppearDefault}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          width="100%"
          templateColumns={["1fr", null, "1fr 1fr"]}
          gap={[6, null, 8, 20]}
          mx={0}
        >
          <Image
            src={image}
            minH="70vh"
            minWidth={["100%", "30vw"]}
            objectFit="contain"
          />
          <Flex justify="center" direction="column">
            {title && (
              <Text type="headline_md" mb="md" color={textColor} fontWeight="500">
                {title}
              </Text>
            )}
            <Description color={textColor} maxW="80%">
              {description}
            </Description>
            <Box>
              <ArrowButton mt="xxl" text={ctaText} href={cta} />
            </Box>
          </Flex>
        </MotionGrid>
      </Container>
    </Box>
  );
}
